import React from "react";
import { Button } from "reactstrap";

export default function CommandButtons({
  searchControl,
  setSearchControl,
  schedules,
  lastSearchStringUpdate,
  getData,
  getReport,
}) {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 10,
        gap: 10,
        flexWrap: "wrap",
      }}
    >
      <form
        className="app-search d-none d-lg-block events-input-search"
        onSubmit={(e) => e.preventDefault()}
      >
        <div className="position-relative">
          <input
            value={searchControl.search}
            type="text"
            inputMode="numeric"
            className="form-control"
            placeholder="Pesquisar por número..."
            onChange={(e) => {
              const _value = e.target.value.replace(/\D/g, '');
              setSearchControl({ ...searchControl, search: _value });
              lastSearchStringUpdate.current = Date.now();
              setTimeout(() => {
                if (lastSearchStringUpdate.current + 500 < Date.now()) {
                  getData();
                }
              }, 600);
            }}
          />
          <span className="bx bx-search-alt" />
        </div>
      </form>

      <div style={{ display: 'flex', flexDirection: 'row', alignItems: "center", gap: 10, margin: 0 }}>
        <Button
          color="success"
          className="waves-effect waves-light"
          style={{ display: "flex", alignItems: "center", gap: 6 }}
          onClick={getReport}
        >
          <i className="fas fa-file-excel" />
          Extrair Relatório
        </Button>
        <select
          className="form-select"
          style={{ width: "auto", minWidth: 200 }}
          value={searchControl.schedule}
          onChange={(e) => {
            setSearchControl({ ...searchControl, schedule: e.target.value });
            setTimeout(() => {
              getData();
            }, 100);
          }}
        >
          {schedules.map((schedule) => (
            <option key={schedule.id} value={schedule.id}>
              {schedule.title}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
